import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { NATIONALITIES } from "../data/nationalities";

export default function NationalitySelect({ value, onValueChange, className = "", triggerClass = "" }) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger data-testid="nationality-select" className={`w-full h-11 border-slate-200 rounded-lg ${triggerClass}`}>
        <SelectValue placeholder="Select nationality" />
      </SelectTrigger>
      <SelectContent className={`bg-white border-slate-200 max-h-60 ${className}`}>
        {NATIONALITIES.map(n => (
          <SelectItem key={n.value} value={n.value}>
            {n.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
